import React, { useState, useRef, useEffect } from 'react';

import TreeEditorPreview from './preview';
import useHashQuery from 'ecommerce/hooks/useHash';

const withHocTreeEditor = Component => {
  const WrappedComponent = props => {
    const [selectedTree, setSelectedTree] = useState();

    const [treeHash, setTreeHash] = useHashQuery("tree")

    const callbackRef = useRef();

    const start = (tree, callback = () => { }) => {
      setTreeHash(null)
      setSelectedTree(tree);

      callbackRef.current = callback;
    };

    const save = () => {
      callbackRef.current();
    };

    const close = () => {
      setTreeHash(undefined)
      setSelectedTree();
    };

    useEffect(() => {
      if (treeHash === undefined) {
        close()
      }
    }, [treeHash])

    const handleOnDoneClick = () => {
      save();
      close();
    };

    return (
      <>
        <Component
          {...props}
          startTreeEditor={start}
          closeTreeEditor={close}
          isTreeEditorOpen={!!selectedTree}
        />
        {selectedTree && <TreeEditorPreview tree={selectedTree} onSuccess={handleOnDoneClick} />}
      </>
    );
  };

  WrappedComponent.getInitialProps = async ctx => {
    if (Component.getInitialProps) {
      return Component.getInitialProps(ctx);
    }

    return {};
  };

  return WrappedComponent;
};

export default withHocTreeEditor;
